import type { IconName } from "../ui/Icon";
import { Seg } from "../ui/Seg";

/** A page's sections or a list's filters (`.k-swb` holding `.k-seg`): 2 to 4 choices, sticking under the top. */
export function Switch<T extends string>({
  options,
  value,
  onChange,
  label,
}: {
  options: ReadonlyArray<{ value: T; label: string; /** An icon before the words, as Faces and List have. */ icon?: IconName }>;
  value: T;
  onChange: (value: T) => void;
  label: string;
}) {
  return (
    <div className="k-swb">
      <Seg className="k-seg" options={options} value={value} onChange={onChange} label={label} />
    </div>
  );
}
